import { render, staticRenderFns } from "./categoryFilter.vue?vue&type=template&id=15c32436&scoped=true&"
import script from "./categoryFilter.vue?vue&type=script&lang=js&"
export * from "./categoryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c32436",
  null
  
)

export default component.exports